'use client'
import { FC, type ReactNode } from 'react'
import { getTransition } from '@/styles'
import { usePageTransition } from '@/hooks'
import type { TypeCmsLayout, TypeLang, TypeDevice } from '@/schema'
import { Navbar } from './layout/Navbar'
import { Footer } from './layout/Footer'
import { AnimatePresence, motion, type Variants } from 'motion/react'
import styled from 'styled-components'
import { TransitionWrapper } from './TransitionWrapper'

type Props = {
  children: ReactNode
  lang?: TypeLang
  headerAgentDeviceType?: TypeDevice
  layoutData: TypeCmsLayout
}


export const TransitionManager: FC<Props> = ({ children, headerAgentDeviceType, layoutData }) => {
  const { cortinaTransitionName } = usePageTransition()
  // console.log('layoutData in TransitionManager:', layoutData)
  return (
    <>
      <AnimatePresence initial={false} >
        <Cortina key='cortina' variants={cortina_variants} initial='initial' animate={cortinaTransitionName === 'covering' ? 'cover' : 'reveal'} exit='exit' className='cortina' />
      </AnimatePresence>
      <Navbar headerAgentDeviceType={headerAgentDeviceType} data={layoutData?.navbar} />
      <TransitionWrapper>
        {children}
      </TransitionWrapper>
      <Footer data={layoutData?.footer} />
    </>
  )
}


const cortina_variants: Variants = {
  initial: {
    scaleY: 0,
    transformOrigin: 'bottom',
  },
  cover: {
    scaleY: 1,
    transformOrigin: 'bottom',
    transition: {
      ...getTransition(),
      duration: 0.5,
      delay: .5,
      ease: 'easeOut'
    }
  },
  reveal: {
    scaleY: 0,
    transformOrigin: 'top',
    transition: {
      ...getTransition(),
      duration: 0.5,
      ease: 'easeIn'
    }
  }
}

const Cortina =  styled(motion.div)`
  height: 100vh;
  width: 100vw;
  background-color: var(--color-creme);
  z-index: 1000000000;
  pointer-events: none;
  user-select: none;
  position: fixed;
  top: 0;
  left: 0;
  transform-origin: bottom;
`
